import React, { useContext, useEffect, useState } from "react";
import { DeviceAdapter } from "@services/catalog/types";
import ListView from "@common/components/ListDetailViews/ListView";
import { columns } from "./colDef";
import {
  ReducerContext,
  ReducerDispatchContext,
} from "@pages/Configuration/DeviceCatalog/context";
import { orderBy } from "lodash";
export enum SelectionBehavior {
  Checkbox = "checkbox",
  Radio = "radio",
}

const AdapterListView = () => {
  const {
    accountId,
    device,
    globalDevice,
    deviceAdapters,
    adapterInherit,
    adapterSelected,
    canEdit,
  } = useContext(ReducerContext);
  const dispatch = useContext(ReducerDispatchContext);
  const [adapterSort, setAdapterSort] = useState<Sort<DeviceAdapter>>({
    column: "lastUpdatedTime",
    direction: "desc",
  });
  const [page, setPage] = useState(1);
  const [pageSize] = useState(50);
  useEffect(() => {
    if (adapterInherit) {
      dispatch({ adapterSelected: globalDevice?.defaultDeviceAdapter?.id });
    } else {
      if (adapterSelected === device?.defaultDeviceAdapter?.id) {
        dispatch({ adapterSelected: device?.defaultDeviceAdapter?.id });
      }
    }
  }, [adapterInherit]);

  useEffect(() => {
    Sort();
  }, [adapterSort]);

  function customSort<T>(
    data: T[],
    sortBy: keyof T,
    direction: "asc" | "desc"
  ): T[] {
    return orderBy(data, sortBy, direction);
  }

  const Sort = () => {
    dispatch({
      deviceAdapters: customSort(
        deviceAdapters,
        adapterSort.column,
        adapterSort.direction
      ),
    });
  };

  const handleSelectAdapter = (selected: (number | undefined)[]) => {
    if (selected[0] !== adapterSelected) {
      dispatch({ adapterSelected: selected[0], isDataChanged: true });
    }
  };

  return (
    <ListView
      data={
        customSort(deviceAdapters, adapterSort.column, adapterSort.direction) ??
        []
      }
      columns={columns}
      loading={deviceAdapters === undefined}
      total={deviceAdapters?.length ?? 0}
      sort={adapterSort}
      onSort={(column, direction) => {
        setAdapterSort({ column, direction });
      }}
      setPage={setPage}
      pageSize={pageSize}
      page={page}
      identityKey="id"
      selectable
      onSelect={handleSelectAdapter}
      selectionBehavior={SelectionBehavior.Radio}
      defaultSelected={
        adapterInherit
          ? globalDevice?.defaultDeviceAdapter
            ? [globalDevice?.defaultDeviceAdapter?.id]
            : deviceAdapters.length > 0
            ? [deviceAdapters[0].id]
            : []
          : [adapterSelected]
      }
      disabledCheckbox={canEdit && !!accountId && adapterInherit}
      sx={{
        flexGrow: 1,
        overflow: "hidden",
        "& > div": { overflowX: "hidden", overflowY: "scroll" },
      }}
      disableColumnResize
    />
  );
};

export default AdapterListView;
